import { RedDay } from "us.collection.admin/constants";

/**
 * @function
 * @description filter and sort red days
 * @param {Array<RedDay>} redDays non-production days list
 * @param { any } selectedCriteria selected format
 * @param { any } selectedYear selected year
 * @returns {Array<RedDay>} filtered array list
 */
export const getFilteredRedDays = (
  redDays: Array<RedDay>,
  selectedCriteria: any,
  selectedYear: any,
): Array<RedDay> => {
  try {
    if (Array.isArray(redDays) && redDays.length > 0) {
      return redDays
        .filter((day: RedDay) => {
          const startYear = new Date(day.startDate).getFullYear();
          const endYear = new Date(day.endDate).getFullYear();
          return (
            day[selectedCriteria as keyof RedDay] === true &&
            (startYear == selectedYear || endYear == selectedYear)
          );
        })
        .sort(
          (a: any, b: any) =>
            new Date(b.startDate).getTime() - new Date(a.startDate).getTime(),
        );
    } else {
      return redDays;
    }
  } catch (error) {
    return redDays;
  }
};
